import React from "react";
import {
  Box,
  Grid,
  Image,
  Text,
  HStack,
  Flex,
  Spacer,
  Link as ChakraLink,
} from "@chakra-ui/react";
import { FiArrowUpRight } from "react-icons/fi";

import badge from "../../../../assets/home/DiscoverDesign/badge.png";
import aignosis from "../../../../assets/cards/aignosis.png";
import srapp from "../../../../assets/cards/srapp.png";
import wavy from "../../../../assets/cards/wavy.png";
import sitha from "../../../../assets/cards/sitha.png";
import indiacourtweb from "../../../../assets/cards/indiacourtweb.png";
import wedmonkey from "../../../../assets/cards/wedmonkey.png";
import indiacourt from "../../../../assets/cards/indiacourt.png";
import rrumi from "../../../../assets/cards/rrumi.png";
import { Link as RouterLink } from "react-router-dom";
import marketing1 from '../../../../assets/cards/marketing1.png'
import marketing2 from '../../../../assets/cards/marketing2.png'
import marketing3 from '../../../../assets/cards/marketing3.png'
import marketing4 from '../../../../assets/cards/marketing4.png'
import marketing5 from '../../../../assets/cards/marketing5.png'
import marketing6 from '../../../../assets/cards/marketing6.png'
import brand1 from '../../../../assets/cards/brand1.png'
import brand2 from '../../../../assets/cards/brand2.png'
import brand3 from '../../../../assets/cards/brand3.png'
import brand4 from '../../../../assets/cards/brand4.png'
import brand5 from '../../../../assets/cards/brand5.png'
import brand6 from '../../../../assets/cards/brand6.png'

// Card data with categories added
const cards = [
  {
    id: 1,
    title: "Aignosis",
    slug: "aignosis",
    bgColor: "#100217",
    gradientColors: ["rgba(255, 100, 100, 0.2)", "rgba(255, 50, 50, 0.1)"],
    image: aignosis,
    badge: badge,
    category: "Website",
    description:
      "Aignosis is a cutting-edge platform for quick and accurate autism detection in kids. With an intuitive interface and expert-backed assessments, it delivers reliable insights for parents. Our team handled UI/UX, development, branding, and marketing. The result—a seamless and impactful experience.",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 2,
    title: "India Court",
    slug: "indiacourt1",
    bgColor: "#0C3420",
    gradientColors: ["rgba(100, 255, 100, 0.2)", "rgba(50, 255, 50, 0.1)"],
    image: indiacourt,
    badge: null,
    category: "Application",
    description:
      "India Court is a legal platform providing free law education, legal assistance, and lawyer services. Get expert advice, document verification, case references, and direct lawyer consultations—all in one place. Legal help made easy and hassle-free!",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 3,
    title: "R'Rumi Diamond",
    slug: "rrumi",
    bgColor: "#003445",
    gradientColors: ["rgba(100, 100, 255, 0.2)", "rgba(50, 50, 255, 0.1)"],
    image: rrumi,
    badge: null,
    category: "Website",
    description:
      "Rrumi Diamond is a Dubai-based luxury jewelry brand offering high-end diamond collections for a sophisticated international clientele. With a seamless online shopping experience, it features GIA-certified diamonds, bespoke designs, and timeless craftsmanship, reflecting the grandeur of the Middle East's luxury market.",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 4,
    title: "Wavvy",
    slug: "wavvy",
    bgColor: "#3B0045",
    gradientColors: ["rgba(200, 100, 255, 0.2)", "rgba(180, 50, 255, 0.1)"],
    image: wavy,
    badge: null,
    category: "Application",
    description:
      "Wavvy is a cutting-edge salon booking app designed for effortless appointment scheduling and seamless beauty service access. Tailored for modern users, Wavvy goes beyond just bookings—creating an engaging digital space for salons, spas, and dermatologists to showcase their expertise, interact with clients, and build a thriving beauty community.",
    engagement: "15mins",
    rating: "4.8/5",
  },
  {
    id: 5,
    title: "WedMonkey",
    slug: "wedmonkey",
    bgColor: "#470E30",
    gradientColors: ["rgba(255, 100, 200, 0.2)", "rgba(255, 50, 180, 0.1)"],
    image: wedmonkey,
    badge: null,
    category: "Website",
    description:
      "WedMonkey offers a curated collection of wedding cards for every style, tradition, and budget. From elegant digital invites to classic prints and modern designs, it makes wedding card selection seamless and hassle-free.",
    engagement: "12mins",
    rating: "4.7/5",
  },
  {
    id: 6,
    title: "SR App",
    slug: "srapp",
    bgColor: "#0D0832",
    gradientColors: ["rgba(100, 200, 255, 0.2)", "rgba(50, 180, 255, 0.1)"],
    image: srapp,
    badge: null,
    category: "Application",
    description:
      "SR App is a smart school management platform for parents, teachers, and administrators. It makes attendance, announcements, homework, fees, and student progress easy to track. With a simple interface, everything is managed in one place. Stay connected and organized effortlessly!",
    engagement: "12mins",
    rating: "4.7/5",
  },
  {
    id: 7,
    title: "LMS App",
    slug: "lmsapp",
    bgColor: "#1D0BA2",
    gradientColors: ["rgba(299, 209, 255, 0.4)", "rgba(299, 209, 255, 0.4)"],
    image: srapp,
    badge: null,
    category: "Application",
    description:
      "India Court is a legal platform providing free law education, legal assistance, and lawyer services. Get expert advice, document verification, case references, and direct lawyer consultations—all in one place. Legal help made easy and hassle-free!",
    engagement: "12mins",
    rating: "4.7/5",
  },
  {
    id: 8,
    title: "Sitha App",
    slug: "sitha",
    bgColor: "#030D3D",
    gradientColors: ["rgba(299, 209, 255, 0.4)", "rgba(299, 209, 255, 0.4)"],
    image: sitha,
    badge: null,
    category: "Application",
    description:
      "Sitha is a women-led service marketplace that connects skilled women professionals with customers. From beauty and wellness to home services, Sitha makes booking safe, easy, and empowering.",
    engagement: "12mins",
    rating: "4.7/5",
  },
  {
    id: 9,
    title: "Souls of India",
    slug: "soi",
    bgColor: "#62066B",
    gradientColors: ["rgba(299, 209, 255, 0.4)", "rgba(299, 209, 255, 0.4)"],
    image: wedmonkey,
    badge: null,
    category: "Website",
    description:
      "Souls of India is a storytelling-driven e-commerce platform that celebrates India’s rich cultural heritage, mindful living, and artisanal craftsmanship. The website showcases handcrafted products, traditional art forms, and soulful stories of Indian artisans—bringing conscious commerce and cultural storytelling together on one platform.",
    engagement: "12mins",
    rating: "4.7/5",
  },
  {
    id: 10,
    title: "India Court",
    slug: "indiacourt",
    bgColor: "#0C3420",
    gradientColors: ["rgba(100, 255, 100, 0.2)", "rgba(50, 255, 50, 0.1)"],
    image: indiacourtweb,
    badge: null,
    category: "Website",
    description:
      "India Court is a legal platform providing free law education, legal assistance, and lawyer services. Get expert advice, document verification, case references, and direct lawyer consultations—all in one place. Legal help made easy and hassle-free!",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 11,
    title: "Aignosis",
    slug: "aignosis",
    bgColor: "#0F0A12",
     gradientColors: [
      "rgba(182, 56, 255, 0.3)",  
      "rgba(160, 50, 255, 0.2)",  
      "rgba(120, 30, 200, 0.1)"  
    ]
    ,
    image: marketing1,
    badge: null,
    category: "Marketing",
    description:
      "Aignosis is a cutting-edge platform for quick and accurate autism detection in kids. With an intuitive interface and expert-backed assessments, it delivers reliable insights for parents. Our team handled UI/UX, development, branding, and marketing. The result—a seamless and impactful experience.",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 12,
    title: "Nari Shakti Awards 2025",
    slug: "narishakti",
    bgColor: "#18020A",
    gradientColors: ["rgba(100, 255, 100, 0.2)", "rgba(50, 255, 50, 0.1)"],
    image: marketing2,
    badge: null,
    category: "Marketing",
    description:
      "The Nari Shakti Awards 2025 is a prestigious platform celebrating the achievements of extraordinary women across India. They needed a strong digital presence to attract nominations and amplify their impact.",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 13,
    title: "Studio 1311 by Manish Kabra",
    slug: "sbmk",
    bgColor: "#1C0303",
    gradientColors: ["rgba(100, 255, 100, 0.2)", "rgba(50, 255, 50, 0.1)"],
    image: marketing3,
    badge: null,
    category: "Marketing",
    description:
      "Studio 1311 by Manasi Kabra is a premium slow fashion brand promoting art through exquisitely crafted shirts. They needed a strong visual identity & organic social media strategy to connect with a niche audience.",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 14,
    title: "PS Events: Event Agency",
    slug: "indiacourt",
    bgColor: "#00222C",
    gradientColors: ["rgba(100, 255, 100, 0.2)", "rgba(50, 255, 50, 0.1)"],
    image: marketing4,
    badge: null,
    category: "Marketing",
    description:
      "At PS Events, we are passionate about transforming your special moments into unforgettable experiences. As the premier event planning agency in Mumbai, we offer personalized and innovative solutions tailored to your unique needs.",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 15,
    title: "Studio 1311 by Manish Kabra",
    slug: "sbmk",
    bgColor: "#0D1812",
    gradientColors: ["rgba(100, 255, 100, 0.2)", "rgba(50, 255, 50, 0.1)"],
    image: marketing5,
    badge: null,
    category: "Marketing",
    description:
      "Studio 1311 by Manasi Kabra is a premium slow fashion brand promoting art through exquisitely crafted shirts. They needed a strong visual identity & organic social media strategy to connect with a niche audience.",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 16,
    title: "Event basket",
    slug: "eventbasket",
    bgColor: "#450014",
    gradientColors: ["rgba(100, 255, 100, 0.2)", "rgba(50, 255, 50, 0.1)"],
    image: marketing6,
    badge: null,
    category: "Marketing",
    description:
      "Event Basket, shaping extraordinary moments since 2017. From Goa's heart to the world stage, we curate unparalleled weddings and events. We are based in Goa, planning destination weddings around the globe, just the way you imagined and in your budget too.",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 17,
    title: "R’Rumi Diamond",
    slug: "rrumi",
    bgColor: "#011414",
    gradientColors: [
      "rgba(0, 68, 67, 0.4)",
      "rgba(100, 255, 100, 0.2)",
      "rgba(50, 255, 50, 0.1)"
    ],
    image: brand1,
    badge: null,
    category: "Branding",
    description:
      "Rrumi Diamond is a Dubai-based luxury jewelry brand offering high-end diamond collections for a sophisticated international clientele. With a seamless online shopping experience, it features GIA-certified diamonds, bespoke designs, and timeless craftsmanship, reflecting the grandeur of the Middle East’s luxury market.",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 18,
    title: "TangoTango",
    slug: "tango",
    bgColor: "#05170D",
    gradientColors: [
      "rgba(144, 238, 144, 0.4)",
      "rgba(124, 252, 0, 0.2)",
      "rgba(173, 255, 47, 0.1)"
    ],
    image: brand2,
    badge: null,
    category: "Branding",
    description:
      "TangoTango is a modern push-to-talk (PTT) solution designed to revolutionize traditional two-way radio communication. Built for first responders, emergency services, and field teams, their app connects existing radio systems to smartphones, computers,LTE networks reducing hardware costs, improving team coordination.",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 19,
    title: "Tazamun Information Tech.",
    slug: "tajamun",
    bgColor: "#021119",
    gradientColors: [
      "rgba(11, 96, 146, 0.4)",
      "rgba(100, 255, 100, 0.2)",
      "rgba(50, 255, 50, 0.1)"
    ],
    image: brand3,
    badge: null,
    category: "Branding",
    description:
      "Tazamun is a startup IT company focused on cloud computing solutions, with an endless passion for programming and design. Long-term, it aims to provide an integrated, easy, and effective digital environment for small and medium-sized businesses to handle the problems of change, a fast-paced competitive climate.",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 20,
    title: "Global Career Engine",
    slug: "global",
    bgColor: "#0E1325",
    gradientColors: [
      "rgba(64, 83, 159, 0.4)",
      "rgba(100, 255, 100, 0.2)",
      "rgba(50, 255, 50, 0.1)"
    ],
    image: brand4,
    badge: null,
    category: "Branding",
    description:
      "BillFlow simplifies subscription billing with a no-code platform. It integrates with Stripe, offering a ready-to-use interface. Built for startups and SaaS companies, it enables easy launch and management. Features like Plan Pickers and Checkout Forms make monetization easy",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 21,
    title: "Wavyy",
    slug: "wavvy",
    bgColor: "#1E1B32",
    gradientColors: ["rgba(100, 255, 100, 0.2)", "rgba(50, 255, 50, 0.1)"],
    image: brand5,
    badge: null,
    category: "Branding",
    description:
      "Wavvy is a cutting-edge salon booking app designed for effortless appointment scheduling and seamless beauty service access. Tailored for modern users, Wavvy goes beyond just bookings—creating an engaging digital space for salons, spas, and dermatologists to showcase their expertise, interact with clients.",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 22,
    title: "India Court",
    slug: "indiacourt",
    bgColor: "#0C3420",
    gradientColors: ["rgba(100, 255, 100, 0.2)", "rgba(50, 255, 50, 0.1)"],
    image: brand6,
    badge: null,
    category: "Branding",
    description:
      "India Court is a legal platform providing free law education, legal assistance, and lawyer services. Get expert advice, document verification, case references, and direct lawyer consultations—all in one place. Legal help made easy and hassle-free!",
    engagement: "10mins",
    rating: "4.9/5",
  },
];

const DesignCards1 = ({ selectedTab }) => {
  const tabs = ["All", "Branding", "Marketing", "Website", "Application"];

  // Filter logic based on selected tab
  const filteredCards =
    selectedTab === 0
      ? cards
      : cards.filter((card) => card.category === tabs[selectedTab]);

  return (
    <Box bg="#F7EAD9" py={10} px={{ base: 4, md: 10 }}>
      <Grid
        templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
        gap={8}
        className="fade-in-up"
      >
        {filteredCards.map((card) => (
          <Flex
            key={card.id}
            direction="column"
            p={6}
            bg={card.bgColor}
            borderRadius="20px"
            color="white"
            minHeight="520px"
            position="relative"
            overflow="hidden"
          >
            {/* Circular Gradient Background */}
            <Box
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              w="300px"
              h="300px"
              borderRadius="50%"
              background={`radial-gradient(circle, ${card.gradientColors[0]}, ${card.gradientColors[1]}, transparent 100%)`}
              filter="blur(20px)"
              opacity="0.8"
              zIndex="0"
            />

            {/* Badge */}
            {card.badge && (
              <Image
                src={card.badge}
                alt="badge"
                position="absolute"
                top="10px"
                left="10px"
                width="60px"
                zIndex="1"
              />
            )}

            {/* Image */}
            <Box
              mt={10}
              mb={6}
              display="flex"
              justifyContent="center"
              height="200px"
              position="relative"
              zIndex="1"
            >
              <Image src={card.image} objectFit="contain" maxH="100%" />
            </Box>

            {/* Spacer */}
            <Spacer />

            {/* Content */}
            <Box position="relative" zIndex="1">
              {/* Title */}

              <ChakraLink
                as={RouterLink}
                to={`/our-work/${card.slug}`}
                fontSize="lg"
                fontWeight="bold"
                display="flex"
                alignItems="center"
                mb={2}
                _hover={{ textDecoration: "underline", color: "#FDD9A0" }}
              >
                {card.title}
                <FiArrowUpRight style={{ marginLeft: "8px" }} />
              </ChakraLink>

              {/* Description */}
              <Text fontSize="sm" fontFamily="Archivo" mb={3}>
                {card.description}
              </Text>

              {/* Meta Info */}
              <HStack justifyContent="space-between">
                <Text fontSize="sm">
                  <strong>Engagement:</strong> {card.engagement}
                </Text>
                <Text fontSize="sm">
                  <strong>Satisfaction:</strong> {card.rating}
                </Text>
              </HStack>
            </Box>
          </Flex>
        ))}
      </Grid>
    </Box>
  );
};

export default DesignCards1;
